<script>
import AuthLogoDefault from './AuthLogoDefault'
import AuthLogoYokohama from './AuthLogoYokohama'
import AuthLogoOsaka from './AuthLogoOsaka'
import AuthLogoToda from './AuthLogoToda'
import { injectFromLocation } from '@/helpers/Provider.js'
const conponent = injectFromLocation(AuthLogoDefault, [
  AuthLogoYokohama,
  AuthLogoOsaka,
  AuthLogoToda,
])
export default {
  extends: conponent,
  name: 'InputMailProvider',
}
</script>
